<template>
    <div>
        <tabs v-if="isReady">
            <tab name="Genel">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Üniversite Düzenle ({{ name }})</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="logo">Logo</label>
                                            <input type="file" @change="onLogo" class="form-control custom-input">
                                            <div v-if="logo">
                                                <img :src="logo" alt="" class="display-img">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="city">Şehir</label>
                                            <select class="form-control custom-input" v-model="city">
                                                <option value selected hidden disabled>Seçiniz...</option>
                                                <option
                                                        v-for="city in cities"
                                                        :key="city.id"
                                                        :value="city.id"
                                                >{{ city.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="name">Üniversite Adı</label>
                                            <input
                                                    type="text"
                                                    v-model="name"
                                                    class="form-control custom-input"
                                                    placeholder
                                            >
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="lat">
                                                Enlem
                                                <small>(x)</small>
                                            </label>
                                            <input
                                                    type="text"
                                                    v-model="lat"
                                                    class="form-control custom-input"
                                                    placeholder
                                            >
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="lng">
                                                Boylam
                                                <small>(y)</small>
                                            </label>
                                            <input
                                                    type="text"
                                                    v-model="lng"
                                                    class="form-control custom-input"
                                                    placeholder
                                            >
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="address">Adres</label>
                                            <input
                                                    type="text"
                                                    v-model="address"
                                                    class="form-control custom-input"
                                                    placeholder
                                            >
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="website">Website</label>
                                            <input
                                                    type="text"
                                                    v-model="website"
                                                    class="form-control custom-input"
                                                    placeholder
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>

            <tab name="Listeleme">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Üniversite Düzenle ({{ name }})</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="title">Başlık</label>
                                            <input class="form-control custom-input" v-model="title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="keywords">Meta Keywords</label>
                                            <textarea class="form-control custom-input" v-model="keywords"
                                                      rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="description">Meta Description</label>
                                            <textarea class="form-control custom-input" v-model="description"
                                                      rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="spot"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="list_seo">Üniversite Description</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="list_seo"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>

            <tab name="Üniv. Tanıtımı">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Üniversite Düzenle ({{ name }})</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="detail_title">Başlık</label>
                                            <input class="form-control custom-input" v-model="detail_title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="detail_keywords">Meta Keywords</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="detail_keywords"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="detail_description">Meta Description</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="detail_description"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="detail_spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="detail_spot"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="content">Üniversite Hakkında</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="content"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Erkek Öğr. SEO">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Üniversite Düzenle ({{ name }})</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="male_title">Başlık</label>
                                            <input class="form-control custom-input" v-model="male_title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="male_keywords">Meta Keywords</label>
                                            <textarea class="form-control custom-input" v-model="male_keywords"
                                                      rows="5"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="male_description">Meta Description</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="male_description"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="male_spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="male_spot"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Kız Öğr. SEO">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Üniversite Düzenle ({{ name }})</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="female_title">Başlık</label>
                                            <input class="form-control custom-input" v-model="female_title">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="female_keywords">Meta Keywords</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="female_keywords"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="female_description">Meta Description</label>
                                            <textarea
                                                    class="form-control custom-input"
                                                    v-model="female_description"
                                                    rows="5"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="female_spot">Spot</label>
                                            <vue-editor :editorToolbar="customToolbar" v-model="female_spot"
                                                        class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Resim Galerisi">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Üniversite Düzenle ({{ name }})</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="gallery">
                                                Resim Galerisi
                                                <small>(Birden fazla seçim yapılabilir)</small>
                                            </label>
                                            <input
                                                    type="file"
                                                    class="form-control custom-input"
                                                    @change="gallery"
                                                    multiple
                                            >
                                        </div>
                                    </div>
                                    <!--  -->
                                    <draggable v-model="images">
                                        <transition-group>
                                            <div class="col-md-4 galleryImage" v-for="image in images" :key="image.id">
                                                <img :src="image.filename" alt class="img-responsive">
                                                <button class="btn btn-danger trash-btn" @click="destroyImage(image)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </transition-group>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
        </tabs>
        <div class="row">
            <div class="col-md-12">
                <div class="widget text-center">
                    <div class="form-elements-sec">
                        <button class="btn btn-success" @click="updateData">Kaydet</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {VueEditor} from "vue2-editor";
    import draggable from 'vuedraggable';

    export default {
        components: {VueEditor, draggable},
        data() {
            return {
                isReady: false,
                customToolbar: [
                    ['bold', 'italic', 'underline'],
                    [{'list': 'ordered'}, {'list': 'bullet'}]
                ],
                id: this.$route.params.id,
                api: "universities/",
                city: "",
                cities: [],
                logo: "",
                name: "",
                lat: "",
                lng: "",
                address: "",
                website: "",
                spot: "",
                content: "",
                title: '',
                keywords: '',
                description: '',
                list_seo: "",
                detail_title: "",
                detail_keywords: "",
                detail_description: "",
                detail_spot: "",
                male_title: "",
                male_keywords: "",
                male_description: "",
                male_spot: "",
                female_title: "",
                female_keywords: "",
                female_description: "",
                female_spot: "",
                images: [],
                campuses: []
            };
        },
        methods: {
            onLogo(event) {
                this.logo = event.target.files[0];
                // console.log(this.logo);
            },
            gallery(e) {
                let selectedFlies = e.target.files;
                if (!selectedFlies.length) {
                    return false;
                }
                for (let i = 0; i < selectedFlies.length; i++) {
                    this.images.push(selectedFlies[i]);
                }
                // console.log(this.images);
            },
            destroyImage(image) {
                this.$Progress.start();
                this.axios.post('university/image-destroy/' + image.id)
                    .then(response => {
                        if (response.status == 200) {
                            var index = this.images.indexOf(image);
                            this.images.splice(index, 1);
                            this.$Progress.finish();
                        }
                    })
            },
            getData() {
                this.axios.get("universities/" + this.id + "/edit")
                    .then(response => {
                    this.cities = response.data.cities;
                    this.city = response.data.university.city_id;
                    this.name = response.data.university.name;
                    this.lat = response.data.university.lat;
                    this.lng = response.data.university.lng;
                    this.address = response.data.university.address;
                    this.website = response.data.university.website;
                    this.content = response.data.university.content;
                    this.campuses = response.data.university.campuses;
                    this.images = response.data.university.images;
                    //
                    this.title = response.data.university.title;
                    this.keywords = response.data.university.keywords;
                    this.description = response.data.university.description;
                    this.spot = response.data.university.spot;
                    this.list_seo = response.data.university.list_seo;
                    //
                    this.detail_title = response.data.university.detail_title;
                    this.detail_keywords = response.data.university.detail_keywords;
                    this.detail_description = response.data.university.detail_description;
                    this.detail_spot = response.data.university.detail_spot;
                    //
                    this.male_title = response.data.university.male_title;
                    this.male_keywords = response.data.university.male_keywords;
                    this.male_description = response.data.university.male_description;
                    this.male_spot = response.data.university.male_spot;
                    //
                    this.female_title = response.data.university.female_title;
                    this.female_keywords = response.data.university.female_keywords;
                    this.female_description = response.data.university.female_description;
                    this.female_spot = response.data.university.female_spot;
                }).then(() => {
                    this.isReady = true;
                });
            },
            updateData() {
                let data = {
                    city: this.city || '',
                    name: this.name || '',
                    lat: this.lat || '',
                    lng: this.lng || '',
                    address: this.address || '',
                    website: this.website || '',
                    list_seo: this.list_seo || '',
                    title: this.title || '',
                    spot: this.spot || '',
                    content: this.content || '',
                    description: this.description || '',
                    keywords: this.keywords || '',
                    detail_title: this.detail_title || '',
                    detail_keywords: this.detail_keywords || '',
                    detail_description: this.detail_description || '',
                    detail_spot: this.detail_spot || '',
                    male_title: this.male_title || '',
                    male_keywords: this.male_keywords || '',
                    male_description: this.male_description || '',
                    male_spot: this.male_spot || '',
                    female_title: this.female_title || '',
                    female_keywords: this.female_keywords || '',
                    female_description: this.female_description || '',
                    female_spot: this.female_spot || '',
                };
                const formData = new FormData();
                if (this.logo) {
                    formData.append("logo", this.logo, this.logo.name);
                }
                if (this.images.length > 0) {
                    for (let i = 0; i < this.images.length; i++) {
                        formData.append("images[]", this.images[i]);
                    }
                }
                formData.append("_method", "PUT");
                Object.keys(data).map(e => {
                    formData.append(e, data[e]);
                });
                this.$Progress.start();
                // eslint-disable-next-line no-unused-vars
                this.axios.post("universities/" + this.id, formData).then(response => {
                    // console.log(response);
                    this.$Progress.finish();
                });
            },
        },
        mounted() {
            this.getData();
        }
    };
</script>

<style scoped>
    .galleryImage {
        margin-bottom: 10px;
        position: relative;
    }

    .galleryImage img {
        border-radius: 6px;
        opacity: 0.7;
    }

    .galleryImage img:hover {
        transition: 0.5s;
        opacity: 1;
    }

    .display-img {
        width: 150px;
    }

    .trash-btn {
        position: absolute;
        top: 15px;
        right: 25px;
    }
</style>
